import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { AttributeContext } from "./AttributeContext";
import AttrList from "./AttrList";
import AddEditViewAttr from "./AddEditViewAttr";
import { AppContext } from "../../../Context/AppContext";
import Label from "../../Common/components/Label";
import GMSButton from "../../Common/components/GMSButton";
import { toast } from "react-toastify";

function AttributeManage(props) {
  const history = useHistory();
  const appData = useContext(AppContext);
  let [attrListApiCompleted, setAttrListApiCompleted] = useState(false);

  const industryId =
    appData.get_selected_industry() && appData.get_selected_industry().id;
  const { deleteinfo, editingItem, setEditingItem } =
    useContext(AttributeContext);
  const [reRender, setReRender] = useState(true);
  useEffect(() => {
    if (editingItem && editingItem.id !== 0) setReRender(false);
    setTimeout(() => {
      setReRender(true);
    }, 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editingItem && editingItem.id]);
  let AttributeContextData = useContext(AttributeContext);

  useEffect(() => {
    appData.pm.hasPermission(
      "gmsattributes_read",
      history,
      "/workspace/module/permission/denied"
    );
    setEditingItem(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [industryId]);
  return (
    <React.Fragment>
      <div className="container-fluid p-0 h-25">
        <div className="row mt-0">
          <div className="col-md-3">
            {deleteinfo.status === "Loading" && (
              <div
                className="alert alert-primary bg-white small p-1"
                role="alert"
              >
                <span className="fas fa-circle-notch fa-spin" />
                &nbsp;
                <strong>{deleteinfo.message}</strong>
              </div>
            )}
            {deleteinfo.status === "Success" && (
              <div
                className="alert alert-primary bg-white small p-1"
                role="alert"
              >
                <span className="fa fa-check" />
                &nbsp;
                <strong>{deleteinfo.message}</strong>
              </div>
            )}
            {deleteinfo.status === "Error" && (
              <div
                className="alert alert-danger bg-white small p-1"
                role="alert"
              >
                <span className="fa fa-exclamation-triangle" />
                &nbsp;
                <strong>{deleteinfo.message}</strong>
              </div>
            )}
          </div>
        </div>

        <div className="d-flex flex-wrap relative">
          <div
            className="col-sm-12 col-md-12 col-lg-2 ps-2 relative md:h-page-content p-0 top-0"
            style={{ borderRight: "2px solid #e6e6e6" }}
          >
            <AttrList
              props={props}
              attrListApiCompleted={attrListApiCompleted}
            />
          </div>
          {editingItem !== null ? (
            <div className="ps-0 pe-0 px-2 col-sm-12 col-md-12 col-lg-10  md:h-page-content md:overflow-y-auto">
              <AddEditViewAttr
                setAttrListApiCompleted={setAttrListApiCompleted}
              />
              {editingItem.id !== "0" && reRender && (
                <div className="" style={{ marginBottom: "50vh" }}></div>
              )}
            </div>
          ) : (
            <div className="col-sm-12 col-md-12 col-lg-10 ps-0 pe-0 ">
              {attrListApiCompleted && (
                <div className="card-body text-dark text-center">
                  <div className="default-page mt-5">
                    <img
                      src={
                        process.env.PUBLIC_URL + "/img/place_holder_no_data.svg"
                      }
                      alt="logo"
                      style={{
                        width: "auto",
                        height: "160px",
                        color: "#091caa",
                      }}
                    />
                    <br />
                    <Label
                      message="No data found"
                      fontSize={2}
                      fontWeight="600"
                      color="#091caa"
                    />
                    <br />
                    <Label
                      message="You can create attributes."
                      fontSize={0.75}
                      fontWeight="500"
                    />
                    <br />
                    <br />
                    <GMSButton
                      name="Create Attributes"
                      onClick={() => {
                        if (
                          appData.pm.checkPermission("gmsattributes_update")
                        ) {
                          if (
                            AttributeContextData.editingItem === null ||
                            AttributeContextData.editingItem.form === "view"
                          ) {
                            AttributeContextData.setEditingItem({
                              form: "edit",
                              id: "0",
                            });
                          } else {
                            AttributeContextData.setEditingItem(null);
                            setTimeout(() => {
                              if (
                                appData.pm.checkPermission(
                                  "gmsattributes_update"
                                )
                              ) {
                                AttributeContextData.setEditingItem({
                                  form: "edit",
                                  id: "0",
                                });
                              } else {
                                toast.info(
                                  "You don't have permission to edit the attribute"
                                );
                              }
                            }, 1000);
                          }
                        } else {
                          toast.info(
                            "You don't have permission to create the attribute"
                          );
                        }
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

export default AttributeManage;
